import { autoserialize, autoserializeAs } from 'cerialize';
import { MobilityAidSelection } from './mobility-aid-selection';
import { ServiceLevel } from './service-level';
import { DateUtil, isNullOrUndefined } from '@uzurv/rideWss/app/util';

export class MobilityProfileDetail {
  // Mobility aids
  @autoserializeAs(MobilityAidSelection)
  manualWheelchair: MobilityAidSelection | null;

  @autoserializeAs(MobilityAidSelection)
  powerWheelchair: MobilityAidSelection | null;

  @autoserializeAs(MobilityAidSelection)
  electricScooter: MobilityAidSelection | null;

  @autoserializeAs(MobilityAidSelection)
  bariatricWheelchair: MobilityAidSelection | null;

  @autoserialize
  hasWalker: boolean;

  @autoserialize
  hasCane: boolean;

  @autoserialize
  hasRollator: boolean;

  // Mobility Assistance
  @autoserialize
  isStairAssistanceRequired: boolean;

  @autoserialize
  hasServiceAnimal: boolean;

  @autoserialize
  hasPersonalCareAssistant: boolean;

  // Medical and Health
  @autoserialize
  hasHearingImpairment: boolean;

  @autoserialize
  hasVisionImpairment: boolean;

  @autoserialize
  hasIntellectualDisability: boolean;

  @autoserialize
  hasPortableOxygen: boolean;

  @autoserializeAs(ServiceLevel)
  recommendedServiceLevel: ServiceLevel;

  @autoserialize
  creationNeeded: boolean;

  @autoserialize
  verificationNeeded: boolean;

  @autoserializeAs(Date)
  modifiedDate: Date;

  @autoserializeAs(Date)
  verifiedAt: Date;

  static OnSeserialized(instance: MobilityProfileDetail, json: any): void {
    if (!isNullOrUndefined(json['modifiedDate'])) {
      json['modifiedDate'] = DateUtil.serializeDate(instance.modifiedDate);
    }

    if (!isNullOrUndefined(json['verifiedAt'])) {
      json['verifiedAt'] = DateUtil.serializeInstant(instance.verifiedAt);
    }
  }

  static OnDeserialized(instance: MobilityProfileDetail, json: any): void {
    if (!isNullOrUndefined(json['modifiedDate'])) {
      instance.modifiedDate = DateUtil.deserializeDate(json['modifiedDate']);
    }

    if (!isNullOrUndefined(json['startDate'])) {
      instance.verifiedAt = DateUtil.deserializeInstant(json['verifiedAt']);
    }
  }
}
